import { useApiUrl, useCustom } from "@refinedev/core";
import { SmlAsset, SmlJsonQuery } from "src/types/intelligence-search";

type GetAssetMetaResponse = {
    errors: [];
    meta: SmlAsset[];
};

export const useAnalyzeQuery = ({
    productCode,
    jsonQuery,
    dataProviderName = "semantic",
    shouldFetchData = true,
}: {
    productCode?: string;
    jsonQuery?: SmlJsonQuery;
    dataProviderName?: string;
    shouldFetchData?: boolean;
}) => {
    const apiUrl = useApiUrl(dataProviderName);
    const encodedJsonQuery = jsonQuery ? btoa(JSON.stringify(jsonQuery)) : undefined;
    const { data, isLoading, isError, refetch, isFetching } = useCustom<GetAssetMetaResponse>({
        url: `${apiUrl}/analyze`,
        method: "get",

        config: {
            headers: {
                "product-code": productCode,
            },
            query: {
                encoded_json_query: encodedJsonQuery,
            },
        },
        dataProviderName: dataProviderName,
        queryOptions: {
            queryKey: [productCode, "analyze", encodedJsonQuery],
            retry: 0,
            enabled:
                shouldFetchData && Boolean(productCode) && Boolean(encodedJsonQuery) && encodedJsonQuery?.length === 0,
            cacheTime: 10 * 60 * 1000,
        },
    });

    return {
        isLoading: isFetching,
        isError,
        meta: data?.data.meta,
        errors: data?.data.errors,
        refetch,
    };
};
